export default function sortDescendingOrder(x: any, y: any): number {
  if (x > y) return -1;
  if (x < y) return 1;
  return 0;
}
